'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _SVGContainer = require('../SVGContainer');

var _SVGContainer2 = _interopRequireDefault(_SVGContainer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SettingsIcon = function SettingsIcon(props) {
  return _react2.default.createElement(
    _SVGContainer2.default,
    props,
    _react2.default.createElement('path', { d: 'M27.5,14 L24.645,14 C24.445,13.21 24.191,12.333 23.867,11.668 L25.899,9.636 C25.993,9.542 26.045,9.415 26.045,9.283 C26.045,9.15 25.992,9.023 25.899,8.929 L23.07,6.102 C22.875,5.906 22.558,5.906 22.363,6.102 L20.33,8.133 C19.666,7.809 18.789,7.555 18,7.356 L18,4.5 C18,4.224 17.776,4 17.5,4 L14.5,4 C14.224,4 14,4.224 14,4.5 L14,7.356 C13.21,7.555 12.333,7.809 11.669,8.133 L9.636,6.102 C9.441,5.906 9.124,5.906 8.929,6.102 L6.1,8.929 C5.905,9.124 5.905,9.441 6.1,9.636 L8.133,11.669 C7.811,12.332 7.555,13.209 7.354,14 L4.5,14 C4.224,14 4,14.224 4,14.5 L4,17.5 C4,17.776 4.224,18 4.5,18 L7.354,18 C7.555,18.791 7.81,19.668 8.133,20.332 L6.1,22.365 C6.006,22.458 5.954,22.585 5.954,22.718 C5.954,22.851 6.007,22.978 6.1,23.072 L8.929,25.9 C9.117,26.088 9.449,26.088 9.636,25.9 L11.669,23.867 C12.332,24.19 13.209,24.444 14,24.646 L14,27.5 C14,27.776 14.224,28 14.5,28 L17.5,28 C17.776,28 18,27.776 18,27.5 L18,24.646 C18.791,24.445 19.668,24.19 20.331,23.868 L22.365,25.9 C22.56,26.095 22.877,26.095 23.072,25.9 L25.9,23.072 C26.095,22.877 26.095,22.56 25.9,22.365 L23.868,20.332 C24.191,19.668 24.446,18.791 24.646,18 L27.5,18 C27.776,18 28,17.776 28,17.5 L28,14.5 C28,14.224 27.776,14 27.5,14 L27.5,14 Z M16,20 C13.794,20 12,18.205 12,16 C12,13.795 13.794,12 16,12 C18.206,12 20,13.795 20,16 C20,18.205 18.206,20 16,20 L16,20 Z' })
  );
};

SettingsIcon.propTypes = {
  size: _react.PropTypes.oneOf(['small', 'medium', 'large'])
};

exports.default = SettingsIcon;